import { BeckyTopology, OneOfTopologyGetter, SiteAssetsTopologyKey, TopologyGetter } from '@wix/thunderbolt-becky-types'
import { BeckyRequestPayload, Topology } from '../../types/becky'

export const DevServerFileRepoUrl = 'static.internalDomain.com/services'
export const HardCodedScriptsUrl = 'static.parastorage.com/services'

export type EnvironmentProps = {
	isSecure: boolean
	isBrowser: boolean
}

const addTrailingSlash = (val: string) => (val.endsWith('/') ? val : `${val}/`)
const dropProtocol = (val: string) => val.replace('https:', '').replace('http:', '')
const toHttp = (val: string) => val.replace('https:', 'http:')
const toHttps = (val: string) => val.replace('http:', 'https:')

const adaptProtocol = (oneOfTopology: OneOfTopologyGetter, isSecure: boolean) => (url: SiteAssetsTopologyKey) =>
	isSecure ? toHttps(oneOfTopology(url)) : toHttp(oneOfTopology(url))

const pickAccordingToEnv = ({ publicEnvironment, environment }: TopologyGetter, isBrowser: boolean) =>
	isBrowser ? publicEnvironment : environment

const toTopology = (oneOfTopologyGetter: OneOfTopologyGetter, staticHTMLComponentUrl: string | undefined): Topology => {
	const fileRepoUrl = oneOfTopologyGetter('fileRepoUrl')

	const safeFileRepoUrl = (!fileRepoUrl || fileRepoUrl.endsWith('://' + DevServerFileRepoUrl)
		? fileRepoUrl.replace(DevServerFileRepoUrl, HardCodedScriptsUrl)
		: fileRepoUrl
	).replace('/services', '')

	return {
		staticMediaUrl: dropProtocol(oneOfTopologyGetter('staticMediaUrl')),
		siteAssetsServerUrl: oneOfTopologyGetter('siteAssetsServerUrl'),
		staticHTMLComponentUrl: staticHTMLComponentUrl!,
		mediaRootUrl: addTrailingSlash(oneOfTopologyGetter('mediaRootUrl')),
		fileRepoUrl: safeFileRepoUrl,
		scriptsUrl: safeFileRepoUrl,
	}
}

export function getBeckyTopology(
	topologyGetter: TopologyGetter,
	{ isHttps, staticHTMLComponentUrl }: BeckyRequestPayload,
	isBrowser: boolean = typeof window !== 'undefined'
): BeckyTopology {
	const isSecure = isHttps === 'true' || isHttps === undefined

	const { publicEnvironment } = topologyGetter
	const environmentTopology = pickAccordingToEnv(topologyGetter, isBrowser)

	return {
		environmentTopology: toTopology(
			isBrowser ? adaptProtocol(environmentTopology, isSecure) : environmentTopology,
			staticHTMLComponentUrl
		),
		publicTopology: toTopology(adaptProtocol(publicEnvironment, isSecure), staticHTMLComponentUrl),
	}
}
